import {
  getCompaniesAsync,
  deleteCompaniesAsync,
  getCompaniesDetailAsync,
  saveCompanyAsync,
  saveCompanyContactPersonAsync,
  deleteCompanyContactAsync,
} from "./CompanyReducer";
import { put, takeLatest } from "redux-saga/effects";
import {
  postCompaniesGetList,
  postCompaniesSaveCompany,
  deleteCompaniesDeleteCompany,
  getCompaniesGetCompany,
  postCompaniesSaveCompanyContactPerson,
  deleteCompaniesDeleteCompanyContactPerson,
  CompanyContactPersonDto,
} from "Api/Api";
import { getType } from "typesafe-actions";
import { call, select } from "typed-redux-saga";
import { toast } from "react-toastify";
import i18next from "i18next";
import { getResourcePath, Resources } from "Translations/Resources";
import { RootStateType } from "State/Store";

function* getCompanies(
  action: ReturnType<typeof getCompaniesAsync.request>,
): Generator {
  try {
    const response = yield* call(postCompaniesGetList, action.payload);
    if (response.status === 200) {
      yield put(getCompaniesAsync.success(response.json));
    } else {
      yield put(getCompaniesAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getCompaniesAsync.failure(err as Error));
  }
}
export function* getCompaniesSaga() {
  yield takeLatest(getType(getCompaniesAsync.request), getCompanies);
}

function* deleteCompany(
  action: ReturnType<typeof deleteCompaniesAsync.request>,
): Generator {
  try {
    const response = yield* call(deleteCompaniesDeleteCompany, action.payload);
    if (response.status === 200) {
      if (response.json.isValid) {
        toast.success(
          i18next.t(getResourcePath(Resources.Companies.List.Delete.Success)),
        );
      } else {
        toast.error(
          i18next.t(
            response.json.validationErrors
              ? response.json.validationErrors[0].message
              : getResourcePath(Resources.Companies.List.Delete.Fail),
          ),
        );
      }
      yield put(
        deleteCompaniesAsync.success({
          id: action.payload,
          result: response.json,
        }),
      );
    } else {
      toast.error(
        i18next.t(getResourcePath(Resources.Companies.List.Delete.Fail)),
      );
      yield put(deleteCompaniesAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(deleteCompaniesAsync.failure(err as Error));
  }
}
export function* deleteCompanySaga() {
  yield takeLatest(getType(deleteCompaniesAsync.request), deleteCompany);
}

function* getCompanyDetail(
  action: ReturnType<typeof getCompaniesDetailAsync.request>,
): Generator {
  try {
    const response = yield* call(getCompaniesGetCompany, action.payload);
    if (response.status === 200) {
      yield put(getCompaniesDetailAsync.success(response.json));
    } else {
      yield put(getCompaniesDetailAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getCompaniesDetailAsync.failure(err as Error));
  }
}
export function* getCompanyDetailSaga() {
  yield takeLatest(getType(getCompaniesDetailAsync.request), getCompanyDetail);
}

function* saveCompanyDetail(
  action: ReturnType<typeof saveCompanyAsync.request>,
): Generator {
  try {
    const response = yield* call(postCompaniesSaveCompany, action.payload);
    if (response.status === 200) {
      toast.success(
        i18next.t(getResourcePath(Resources.CompanyEdit.SaveSuccess)),
      );
      yield put(saveCompanyAsync.success(response.json));
    } else {
      toast.error(i18next.t(getResourcePath(Resources.CompanyEdit.SaveFail)));
      yield put(saveCompanyAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(saveCompanyAsync.failure(err as Error));
  }
}
export function* saveCompanyDetailSaga() {
  yield takeLatest(getType(saveCompanyAsync.request), saveCompanyDetail);
}

function* saveCompanyContactPerson(
  action: ReturnType<typeof saveCompanyContactPersonAsync.request>,
): Generator {
  try {
    const response = yield* call(
      postCompaniesSaveCompanyContactPerson,
      action.payload,
    );
    if (response.status === 200 && response.json.isValid) {
      toast.success(
        i18next.t(
          getResourcePath(Resources.CompanyEdit.ContactEdit.Save.Success),
        ),
      );
      const data = response.json.data as CompanyContactPersonDto | null;
      if (data) {
        const { person, user } = yield* select((state: RootStateType) => ({
          person: state.companies.companyDetail?.contacts.find(
            x => x.companyContactPersonID === data.companyContactPersonID,
          ),
          user: state.auth.user,
        }));

        data.positionName = action.payload.positionName;

        data.charges.forEach(c => {
          const charge = person?.charges.find(
            x =>
              x.companyContactPersonChargeID === c.companyContactPersonChargeID,
          );
          c.createdByFirstName =
            charge?.createdByFirstName ?? user?.firstName ?? "";
          c.createdByLastName =
            charge?.createdByLastName ?? user?.lastName ?? "";
        });
      }
      yield put(saveCompanyContactPersonAsync.success(response.json));
    } else {
      if (response.json.validationErrors?.length) {
        toast.warning(response.json.validationErrors[0].message);
      } else {
        toast.error(
          i18next.t(
            getResourcePath(Resources.CompanyEdit.ContactEdit.Save.Error),
          ),
        );
      }
      yield put(saveCompanyContactPersonAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(saveCompanyContactPersonAsync.failure(err as Error));
  }
}
export function* saveCompanyContactPersonSaga() {
  yield takeLatest(
    getType(saveCompanyContactPersonAsync.request),
    saveCompanyContactPerson,
  );
}

function* deleteCompanyContactPerson(
  action: ReturnType<typeof deleteCompanyContactAsync.request>,
): Generator {
  try {
    const response = yield* call(
      deleteCompaniesDeleteCompanyContactPerson,
      action.payload,
    );
    if (response.status === 200) {
      toast.success("Kontakt úspěšně smazán");
      yield put(deleteCompanyContactAsync.success(response.json));
    } else {
      toast.error("Nastala chyba na serveru");
      yield put(deleteCompanyContactAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(deleteCompanyContactAsync.failure(err as Error));
  }
}
export function* deleteCompanyContactPersonSaga() {
  yield takeLatest(
    getType(deleteCompanyContactAsync.request),
    deleteCompanyContactPerson,
  );
}
